<template>
  <div class="layout-list">
    <div class="row">
      <div class="small-3 columns small-centered">
        <error-reveal :error="error"></error-reveal>
      </div>
    </div>
    <div class="row small-collapse">
      <div class="small-12 columns">
        <data-grid
          :items="items"
          :columns="columns"
          :addNewEnabled="true"
          @additem="onAddNewItem"
          @itemaction="onItemAction"
          @refresh="onGridRefresh"
        ></data-grid>
      </div>
    </div>
    <data-store
      ref="store"
      :service="service"
      :filter="filter"
      :sort="sort"
      @beforeload="onBeforeLoad"
      @afterload="onAfterLoad"
      @dataloaded="onDataLoaded"
      @loaderror="onLoadError"
    ></data-store>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapMutations } from 'vuex'
import * as mutationTypes from '../../store/mutation-types'
import DataGrid from '../../lists/DataGrid'
import DataStore from '../../data/Store'
import ErrorReveal from '../../errors/Reveal'
import userService from '../../services/user'
import i18nService from '../../services/i18n'
import Confirm from '../../mixins/Confirm'

export default {
  name: 'feeds-list',
  mixins: [Confirm],
  components: {
    DataGrid,
    DataStore,
    ErrorReveal
  },
  data () {
    return {
      items: [],
      columns: [{
        title: 'Név / email',
        name: 'nameAndEmail'
      }, {
        title: 'Hozzáférés',
        name: 'access',
        width: 150
      }, {
        title: 'Jogosultság',
        name: 'role',
        width: 100
      }, {
        title: 'Regisztráció dátuma',
        name: 'createdAt',
        width: 150,
        align: 'center'
      }, {
        actions: [{
          name: 'edit',
          html: '<i class="fi-page-edit"></i> Szerkesztés'
        }, {
          name: 'toggleAccess',
          html: '<i class="fi-page-edit"></i> Engedélyezés / tiltás'
        }, {
          name: 'delete',
          html: '<i class="fi-trash"></i> Törlés',
          class: 'alert'
        }],
        width: 230,
        align: 'center'
      }],
      service: userService.list,
      filter: null,
      sort: null,
      error: null
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    ...mapMutations([mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF]),
    onBeforeLoad () {
      this[mutationTypes.BUSY_ON]()
    },
    onAfterLoad () {
      this[mutationTypes.BUSY_OFF]()
    },
    onDataLoaded (items, result) {
      this.items = items.filter((item) => item.id !== this.user.id).map(this.parseItem)
    },
    onLoadError (error) {
      this[mutationTypes.BUSY_OFF]()
      this.error = error
    },
    onAddNewItem () {
      this.$router.push({name: 'user-edit'})
    },
    onItemAction (action, item) {
      if (action.name === 'edit') {
        this.$router.push({name: 'user-edit', params: {id: item.id}})
      }
      if (action.name === 'delete') {
        this.onDeleteUser(item)
      }
      if (action.name === 'toggleAccess') {
        this.onToggleAccess(item)
      }
    },
    onGridRefresh () {
      this.$refs.store.load()
    },
    onDeleteUser (item) {
      this.confirm('Törlés', 'Biztos vagy benne?').then((confirmed) => {
        if (confirmed) {
          this[mutationTypes.BUSY_ON]()
          userService.remove(item.id).then((data) => {
            this[mutationTypes.BUSY_OFF]()
            this.onGridRefresh()
          })
          .catch(() => {
            this[mutationTypes.BUSY_OFF]()
          })
        }
      })
    },
    onToggleAccess (item) {
      this[mutationTypes.BUSY_ON]()
      userService.toggleAccess(item.id).then((data) => {
        this[mutationTypes.BUSY_OFF]()
        this.onGridRefresh()
      })
      .catch(() => {
        this[mutationTypes.BUSY_OFF]()
      })
    },
    parseItem (rawData) {
      return {
        id: rawData.id,
        displayName: rawData.displayName,
        nameAndEmail: this.renderNameAndEmail(rawData),
        access: this.renderAccess(rawData.accessGranted),
        role: this.renderRole(rawData.role),
        createdAt: i18nService.formatDateTime(rawData.createdAt, i18nService.FMT_SHORT, i18nService.FMT_SHORT)
      }
    },
    renderNameAndEmail (data) {
      return `${data.displayName}<br>${data.email || '-'}`
    },
    renderAccess (accessGranted) {
      return accessGranted ? 'Engedélyezve' : 'Tiltva'
    },
    renderRole (role) {
      let titles = {
        'user': 'Vendég',
        'admin': 'Admin'
      }

      return _.get(titles, role, 'n/a')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../../sass/foundation-import';
  @import '../../../sass/layouts/list';
</style>



// WEBPACK FOOTER //
// List.vue?113a85b8